import { Button, Col, Row } from "antd";
import moment from "moment";
import { getData, updateData } from "../../helpers/api";
import { useCallback, useEffect, useState } from "react";
import SelectInput from "../../components/inputs/SelectInput";
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import TableLayout from "../../components/layouts/TableLayout";
import { use } from "react";


const FallowPayment = () => {
    const [userId, setUserId] = useState(null)
    const [salaryHistory, setSalaryHistory] = useState({
        salary: [],
        total: 0
    })
    const [paymentStates, setPaymentStates] = useState({
        totalPayed: 0,
        totalNotPayed: 0
    })
    const [users, setUsers] = useState([])

    const getSalaryHistory = useCallback(async (page = 1, limit = 10) => {
        const res = await getData(`/salary/user`, { userId, page, limit })
        setSalaryHistory(res.data)
    }, [userId])

    const paySalaray = async () => {
        try {
            const res = await updateData(`/salary/user/${userId}`)
            if (res.status === 200) {
                getSalaryHistory()
            }
        } catch (error) {

        }
    }

    const getSalaryCountPayment = useCallback(async () => {
        const res = await getData(`/salary/payment`, { userId })
        return setPaymentStates(res.data)
    }, [userId])

    const getUsers = async () => {
        try {
            const res = await getData('/users/fallow')
            setUsers(res.data.map((user) => ({ value: user.id, label: user.name })))
        } catch (error) {

        }
    }

    const salaryColumns = [
        {
            title: "Salaire",
            dataIndex: "salary",
            key: "salary",
        },
        {
            title: "Mois",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (text) => <div>{moment(text).subtract(1, 'month').format('YYYY-MM')}</div>
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (text, record) => {
                return (
                    <>
                        {record.isPayed ? <Button type="primary" disabled>Payé</Button> : <Button onClick={() => paySalaray()} type="primary">Payer</Button>}
                    </>
                )
            },
        }
    ]

    useEffect(() => {
        if (userId) {
            getSalaryHistory()
            getSalaryCountPayment()
        }
    }, [getSalaryCountPayment, getSalaryHistory, userId])

    useEffect(() => {
        getUsers()
    }, [])
    return (
        <>
            <Row>
                <Col span={12}>
                    <Formik
                        initialValues={{ userId: null }}
                        validationSchema={Yup.object({
                            userId: Yup.number().required('required'),
                        })}
                        onSubmit={(values, _) => {
                            setUserId(values.userId)
                        }}
                    >
                        <Form>
                            <Row gutter={[16, 16]}>
                                <Col span={24} style={{ textAlign: "left" }}>Selectionner un emplyee</Col>
                                <Col span={6}>
                                    <SelectInput
                                        name="userId"
                                        size="large"
                                        placeholder={"Emplyee"}
                                        options={users}
                                    />
                                </Col>
                                <Col span={4}>
                                    <Button size='large' type="primary" htmlType="submit">
                                        Selectionner
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Formik>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <h2>Total payé : {paymentStates.totalPayed}</h2>
                    <h2>Total non payé : {paymentStates.totalNotPayed}</h2>
                </Col>
            </Row>
            <TableLayout
                columns={salaryColumns}
                total={salaryHistory.total}
                dataSource={salaryHistory.salary}
                getData={getSalaryHistory}
                displayAddBtn={true}
            />
        </>
    );
}

export default FallowPayment;